import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/lib/api";
import { clearCharm } from "@/hooks/useCharm";

export const PRESET_KEY = "lz_preset";
export const CHAR_BG_KEY = "lz_char_bg";

export const useMakeBracelet = () => {
  const nav = useNavigate();
  const loc = useLocation();
  return (beads, image = null) => {
    clearCharm();
    window.dispatchEvent(new CustomEvent("lz:charm", { detail: null }));
    if (image) sessionStorage.setItem(CHAR_BG_KEY, image);
    else sessionStorage.removeItem(CHAR_BG_KEY);
    window.dispatchEvent(new CustomEvent("lz:charbg", { detail: image }));
    if (loc.pathname === "/") {
      window.dispatchEvent(new CustomEvent("lz:preset", { detail: beads }));
      scrollToId("design");
      return;
    }
    sessionStorage.setItem(PRESET_KEY, JSON.stringify(beads));
    nav("/");
  };
};
